import {
  Box,
  Divider,
  Grid,
  GridColumn,
  Text,
  ThemeProvider
} from "@modernatx/ui-kit-react";
import React from "react";

import { formattedPrice } from "@/utils/Helper";

interface DisplayProductInfoProps {
  productName: string;
  doses: string | undefined;
  contractPrice: string | undefined;
  finalPrice: string | undefined;
}

const DisplayProductInfo: React.FC<DisplayProductInfoProps> = (
  props: DisplayProductInfoProps
) => {
  const { productName, doses, contractPrice, finalPrice } = props;
  const isMresvia = productName.includes("mRESVIA");
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "start",
        maxWidth: "50%"
      }}
    >
      <Text variant="body-1-bold">{productName}</Text>
      <Text variant="body-1-regular">Doses: {doses}</Text>
      <Text variant="body-1-regular">Contract price: {contractPrice}</Text>
      {!isMresvia && (
        <Text variant="body-1-regular">
          Price per dose with online discount: {finalPrice}
        </Text>
      )}
    </Box>
  );
};

interface OrderTableProps {
  productRows: [
    {
      title: string;
      doses: string;
      contractPriceValue: string;
      finalPriceValue: string;
    }
  ];
  subTotal: number;
  totalDoses: number;
}

const OrderTable: React.FC<OrderTableProps> = ({
  productRows,
  subTotal,
  totalDoses
}) => {
  const productDisplay = productRows.map(
    (
      row: {
        title: string;
        doses: string;
        contractPriceValue: string;
        finalPriceValue: string;
      },
      index: number
    ) => {
      const itemSubtotal = Number(row.doses) * Number(row.finalPriceValue);
      return (
        <Box
          key={`product-row-${index}`}
          sx={{
            display: "flex",
            justifyContent: "space-between",
            mt: "spacing-3"
          }}
        >
          <DisplayProductInfo
            productName={row.title}
            doses={row.doses}
            contractPrice={formattedPrice(row.contractPriceValue)}
            finalPrice={formattedPrice(row.finalPriceValue)}
          />
          <Text variant="body-1-bold">{formattedPrice(itemSubtotal)}</Text>
        </Box>
      );
    }
  );

  return (
    <ThemeProvider>
      <Box sx={{ width: "100%", display: "flex", justifyContent: "start" }}>
        <GridColumn>
          <Box
            sx={{
              pt: "spacing-4",
              pb: "spacing-6"
            }}
          >
            <Grid>
              <GridColumn>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    mt: "spacing-3"
                  }}
                >
                  <Text variant="body-1-medium">{"PRODUCT"}</Text>
                  <Text variant="body-1-medium">{"SUBTOTAL"}</Text>
                </Box>
                <Box sx={{ pt: "spacing-4", pb: "spacing-2" }}>
                  <Divider color="color-system-gray-300" />
                </Box>
                <Box
                  sx={{ display: "flex", gap: "2", flexDirection: "column" }}
                >
                  {productDisplay}
                </Box>
              </GridColumn>
            </Grid>
            <Box sx={{ pt: "spacing-4", pb: "spacing-2" }}>
              <Divider color="color-system-gray-300" />
            </Box>
            <Grid>
              <GridColumn>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    mt: "spacing-3"
                  }}
                >
                  <Text variant="body-1-bold">
                    Subtotal for {totalDoses} doses
                  </Text>
                  <Text variant="body-1-bold">{formattedPrice(subTotal)}</Text>
                </Box>
              </GridColumn>
            </Grid>
          </Box>
        </GridColumn>
      </Box>
    </ThemeProvider>
  );
};

export default OrderTable;
